<template>
	<v-container fluid class="ctes-mdfe-page pa-8 pt-12">
		<div class="ctes-mdfe-header">
			<div>
				<h1 class="ctes-mdfe-title">CT-e / MDF-e</h1>
				<p class="ctes-mdfe-subtitle">
					Modulo de documentos fiscais de transporte.
				</p>
			</div>
		</div>
	</v-container>
</template>

<script>
export default {
	name: "IndexCtesMdfe",
};
</script>

<style scoped>
@import "../../assets/inter-font.css";

.ctes-mdfe-page {
	background: linear-gradient(180deg, #f8fbff 0%, #f3f7fb 100%);
	min-height: 100%;
	font-family: "Inter", sans-serif;
}

.ctes-mdfe-header {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 16px;
	flex-wrap: wrap;
}

.ctes-mdfe-title {
	margin: 0;
	font-size: 22px;
	font-weight: 800;
	line-height: 1.2;
	color: #10b981;
}

.ctes-mdfe-subtitle {
	margin: 6px 0 0;
	max-width: 640px;
	font-size: 13px;
	color: #7a8ca6;
}

@media (max-width: 960px) {
	.ctes-mdfe-page {
		padding: 24px 16px !important;
	}

	.ctes-mdfe-title {
		font-size: 22px;
	}
}
</style>